const MODULE_NAME = 'fulcrum/container/Project/WeeklyUpdateSection'

const FETCH_WEEKLY_UPDATES = MODULE_NAME + '/FETCH_WEEKLY_UPDATES'
const FETCH_WEEKLY_UPDATES_START = MODULE_NAME + '/FETCH_WEEKLY_UPDATES_START'
const FETCH_WEEKLY_UPDATES_SUCCESS = MODULE_NAME + '/FETCH_WEEKLY_UPDATES_SUCCESS'
const FETCH_WEEKLY_UPDATES_ERROR = MODULE_NAME + '/FETCH_WEEKLY_UPDATES_ERROR'

const FETCH_REMAINING_WEEKLY_UPDATES = MODULE_NAME + '/FETCH_REMAINING_WEEKLY_UPDATES'
const FETCH_REMAINING_WEEKLY_UPDATES_START = MODULE_NAME + '/FETCH_REMAINING_WEEKLY_UPDATES_START'
const FETCH_REMAINING_WEEKLY_UPDATES_SUCCESS = MODULE_NAME + '/FETCH_REMAINING_WEEKLY_UPDATES_SUCCESS'
const FETCH_REMAINING_WEEKLY_UPDATES_ERROR = MODULE_NAME + '/FETCH_REMAINING_WEEKLY_UPDATES_ERROR'

const POST_WEEKLY_UPDATE = MODULE_NAME + '/POST_WEEKLY_UPDATE'
const POST_WEEKLY_UPDATE_START = MODULE_NAME + '/POST_WEEKLY_UPDATE_START'
const POST_WEEKLY_UPDATE_SUCCESS = MODULE_NAME + '/POST_WEEKLY_UPDATE_SUCCESS'
const POST_WEEKLY_UPDATE_ERROR = MODULE_NAME + '/POST_WEEKLY_UPDATE_ERROR'

const DELETE_WEEKLY_UPDATE = MODULE_NAME + '/DELETE_WEEKLY_UPDATE'
const DELETE_WEEKLY_UPDATE_START = MODULE_NAME + '/DELETE_WEEKLY_UPDATE_START'
const DELETE_WEEKLY_UPDATE_SUCCESS = MODULE_NAME + '/DELETE_WEEKLY_UPDATE_SUCCESS'
const DELETE_WEEKLY_UPDATE_ERROR = MODULE_NAME + '/DELETE_WEEKLY_UPDATE_ERROR'

const UPDATE_WEEK_NUMBER = MODULE_NAME + '/UPDATE_WEEK_NUMBER'
const UPDATE_YEAR = MODULE_NAME + '/UPDATE_YEAR'
const UPDATE_ROLE = MODULE_NAME + '/UPDATE_ROLE'
const UPDATE_TEXT = MODULE_NAME + '/UPDATE_TEXT'

const UPDATE_TOTAL_COUNT = MODULE_NAME + '/UPDATE_TOTAL_COUNT'
const RESET_TOTAL_COUNT = MODULE_NAME + '/RESET_TOTAL_COUNT'
const INCREMENT_TOTAL_COUNT = MODULE_NAME + '/INCREMENT_TOTAL_COUNT'
const DECREMENT_TOTAL_COUNT = MODULE_NAME + '/DECREMENT_TOTAL_COUNT'

const RESET_NEW_WEEKLY_UPDATE = MODULE_NAME + '/RESET_NEW_WEEKLY_UPDATE'

export {
  MODULE_NAME,
  FETCH_WEEKLY_UPDATES,
  FETCH_WEEKLY_UPDATES_START,
  FETCH_WEEKLY_UPDATES_SUCCESS,
  FETCH_WEEKLY_UPDATES_ERROR,
  FETCH_REMAINING_WEEKLY_UPDATES,
  FETCH_REMAINING_WEEKLY_UPDATES_START,
  FETCH_REMAINING_WEEKLY_UPDATES_SUCCESS,
  FETCH_REMAINING_WEEKLY_UPDATES_ERROR,
  POST_WEEKLY_UPDATE,
  POST_WEEKLY_UPDATE_START,
  POST_WEEKLY_UPDATE_SUCCESS,
  POST_WEEKLY_UPDATE_ERROR,
  DELETE_WEEKLY_UPDATE,
  DELETE_WEEKLY_UPDATE_START,
  DELETE_WEEKLY_UPDATE_SUCCESS,
  DELETE_WEEKLY_UPDATE_ERROR,
  RESET_NEW_WEEKLY_UPDATE,
  UPDATE_WEEK_NUMBER,
  UPDATE_YEAR,
  UPDATE_ROLE,
  UPDATE_TEXT,
  UPDATE_TOTAL_COUNT,
  RESET_TOTAL_COUNT,
  INCREMENT_TOTAL_COUNT,
  DECREMENT_TOTAL_COUNT
}
